<template>
    <div class="flex flex-wrap">
        <div class="flex  items-center formLabel" v-for="(category, index) in categoryArray" :key="index">
            <h6 @click="searchCategory(category.id)" class="yellow pointer">{{ category.name }}</h6>
            <div class="ph2" v-if="index < categoryArray.length - 1">/</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categoryLevels: {
            type: Array
        }
    },
    data() {
        return {
            categoryArray: this.categoryLevels
        };
    },
    methods: {
        searchCategory(id) {
            this.$router.push({ path: '/search', query: { category: id } });
        }
    }
};
</script>
